import React, { useState, useEffect, useRef } from 'react';
import './Carousel.css';

// Import slider images
import slider1 from '../../assets/images/slider-images/Image-scaled.jpg';
import slider2 from '../../assets/images/slider-images/Image-1.jpg';
import slider3 from '../../assets/images/slider-images/Image-2.jpg';
import slider4 from '../../assets/images/slider-images/Image-3.jpg';
import slider5 from '../../assets/images/slider-images/Image.jpg';

const Carousel = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const timeoutRef = useRef(null);
  
  const sliderImages = [
    { src: slider1, alt: "Slide 1" },
    { src: slider2, alt: "Slide 2" },
    { src: slider3, alt: "Slide 3" },
    { src: slider4, alt: "Slide 4" },
    { src: slider5, alt: "Slide 5" }
  ];
  
  const resetTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  };
  
  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setActiveIndex((prevIndex) =>
          prevIndex === sliderImages.length - 1 ? 0 : prevIndex + 1
        ),
      5000
    );
    
    return () => {
      resetTimeout();
    };
  }, [activeIndex, sliderImages.length]);
  
  const goToSlide = (index) => {
    setActiveIndex(index);
  };
  
  const goToPrevSlide = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === 0 ? sliderImages.length - 1 : prevIndex - 1
    );
  };
  
  const goToNextSlide = () => {
    setActiveIndex((prevIndex) => 
      prevIndex === sliderImages.length - 1 ? 0 : prevIndex + 1
    );
  };
  
  return (
    <div className="slider index-3">
      <div className="owl-main owl-carousel">
        {sliderImages.map((slide, index) => (
          <div 
            key={index} 
            className={`item ${index === activeIndex ? 'active' : ''}`}
            style={{ display: index === activeIndex ? 'block' : 'none' }}
          >
            <img className="d-block w-100" src={slide.src} alt={slide.alt} />
            <div className="caption d-md-block">
              <div className="display"></div>
            </div>
          </div>
        ))}
        
        <div className="carousel-controls">
          <button className="carousel-control-prev" onClick={goToPrevSlide}>
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="sr-only">Previous</span>
          </button>
          <button className="carousel-control-next" onClick={goToNextSlide}>
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="sr-only">Next</span>
          </button>
        </div>
        
        <div className="carousel-indicators">
          {sliderImages.map((_, index) => (
            <button
              key={index}
              type="button"
              className={index === activeIndex ? 'active' : ''}
              onClick={() => goToSlide(index)}
              aria-label={`Slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;